import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const getDeckingSection: DocumentNode = gql`
  query deckingSection($id: Int!) {
    deckingSection(id: $id) {
      depth
    }
  }
`;

export const getAncillaries: DocumentNode = gql`
  query ancillaries {
    ancillaries(filter: { available: true }, orderBy: favouriteListOrder_ASC) {
      id
      shortDescription
      longDescription
      favourite
      distributorEnabled
      unitCost
      ancillaryType {
        id
        name
      }
      ancillaryUnit {
        id
        name
      }
    }
  }
`;
